import React from 'react';
import styles from './style.scss';
import { Modal } from 'jd-library';

const ObjectionContentModal = props => {
    const {objectionableCount,objectionableProductCount,objectionableServiceCount} = props.apiData;
    let headingTxt = '',paraTxt = '';
    if(objectionableProductCount) {
        headingTxt = objectionableProductCount > 1 ? 'Products' : 'Product';
    }
    if(objectionableServiceCount) {
        headingTxt = headingTxt ? headingTxt.split('s')[0]+'s/Services' : (objectionableServiceCount > 1 ? 'Services' : 'Service');
    }
    paraTxt = headingTxt.toLowerCase();
    return (
        <Modal
            settings={{
                modalId: 'ObjectionalProduct',
                variant: 'action',
                class: styles["objectional-product-modal"],
            }}
            onHidden={props.onHidden}
        >
            <Modal.Header className={styles['modal-heading']}>{`${objectionableCount} ${headingTxt} Found with Objectionable Content`}</Modal.Header>
            <Modal.Body className={styles['modal-body']}>{`These ${paraTxt} will be audited by our internal team within 3 working days`}</Modal.Body>
            <Modal.CenterButton
                onClick={() => {
                    window.history.back();
                }}
            >
			    Okay, Got it
		    </Modal.CenterButton>
        </Modal>
    )
};

export default ObjectionContentModal;